import AdServiceIcon from "@/assets/images/ad-service.svg";
import buildIcon from "@/assets/images/build.svg";
import RightMark from "@/assets/images/rightMark.svg";
import VerifiedIcon from "@/assets/images/verified.svg";
import { Checkbox } from "@/components/ui/checkbox";
import { formatCurrency } from "@/utils/formatCurrency";
import Image from "next/image";
import React from "react";
import InstallationSkeleton from "../Skeletons/InstallationSkeleton";

const InstallationServices = ({
  isFetching,
  addOnsPayload,
  setAddOnsPayload,
  categoryName,
  addOnServices,
}) => {
  const [installationService = null, haulAwayService = null] = addOnServices;

  const isQuoteRequest = !installationService;

  const isMultipleInstallationService = Array.isArray(installationService);

  const {
    installationFee,
    InstallationPart = [],
    installationServiceId,
  } = installationService || {};

  const {
    haulAway,
    moveAway,
    haulAwayPrice = 0,
    moveAwayPrice = 0,
    installationServiceId: additionalServiceId,
    isActive: isPrimum,
  } = haulAwayService || {};

  const [installation = null, ...installationParts] = InstallationPart;

  const onCheckedChange = () => {
    const serviceId = isMultipleInstallationService
      ? installationService[0]?.variableServices[0]?.installationServiceId
      : installationServiceId;

    const serviceDetail = isMultipleInstallationService
      ? { installationFee: installationService?.[0]?.installationFee }
      : installationService;

    // const additionServices = isPrimum
    //   ? { haulaway: true, moveAway: false, additionalServiceId }
    //   : {
    //       haulaway: addOnsPayload?.additionServices?.haulaway,
    //       moveAway: addOnsPayload?.additionServices?.moveAway,
    //     };

    // const haulAwayPrice =
    //   ((isPrimum || isQuoteRequest) && "0") || addOnsPayload.haulAwayPrice;
    // const moveAwayPrice =
    //   ((isPrimum || isQuoteRequest) && "0") || addOnsPayload.moveAwayPrice;

    setAddOnsPayload((prev) => ({
      ...prev,
      // additionServices,
      // haulAwayPrice,
      // moveAwayPrice,
      installationServiceId: serviceId,
      installationService: serviceDetail,
      installationParts: [],
      ...(isQuoteRequest && { quoteOnly: true }),
    }));
  };
  const handleOnNoCheckedChange = () => {
    setAddOnsPayload((prev) => ({
      ...prev,
      installationServiceId: null,
      installationService: {},
      installationParts: [],
      quoteOnly: false,
    }));
  };

  const getAdditionServicePriceLabel = (price) => {
    return formatCurrency(price);
  };

  const handleAdditionalCheckboxChange = (key, checked) => {
    setAddOnsPayload((prev) => ({
      ...prev,
      additionServices: {
        moveAway:
          key === "moveAway" ? !prev?.additionServices?.moveAway : false,
        haulaway:
          key === "haulaway" ? !prev?.additionServices?.haulaway : false,
        additionalServiceId,
      },
      moveAwayPrice: key === "moveAway" && checked ? moveAwayPrice : "0",
      haulAwayPrice: key === "haulaway" && checked ? haulAwayPrice : "0",
    }));
  };

  return (
    <div className=" px-[30px] pt-[30px] pb-4 mob:px-[20px] mob:pt-[20px] ">
      <h3 className=" text-[18px] leading-[27px] text-black font-medium mb-6 ">
        Next, let’s review service options.
      </h3>
      {isFetching && <InstallationSkeleton />}

      {!isFetching && (
        <div className="border border-gray-14 rounded-10 px-[14px] py-[18px]">
          <div className="flex gap-4 border-b border-gray-14 pb-[18px] mb-[18px]">
            <Image
              src={buildIcon}
              className="w-[27px] h-[27px] mt-4px"
              alt="icon"
            />
            <div>
              <h4 className="text-[17px] leading-[26px] font-medium mb-[5px]">
                Installation Services
              </h4>
            </div>
          </div>

          <div className="flex flex-col space-y-1">
            <div className="flex items-start space-x-2">
              <Checkbox
                checked={
                  isMultipleInstallationService
                    ? addOnsPayload.installationServiceId
                    : addOnsPayload.installationServiceId ===
                        installationServiceId || addOnsPayload.quoteOnly
                }
                onCheckedChange={onCheckedChange}
              />

              <div className="flex-1 flex items-center justify-between">
                <div className="inline-flex items-center gap-2">
                  <p className="text-[15px] leading-[19px]">
                    {isQuoteRequest
                      ? "Installation Quote Request"
                      : `${categoryName} Installation`}
                  </p>
                  <Image
                    className="w-[18px] h-[18px] mr-[3px]"
                    src={VerifiedIcon}
                    alt="icon"
                  />
                </div>
                <p className="text-[14px] leading-[19px] font-medium">
                  {formatCurrency(
                    installationFee || installationService?.[0]?.installationFee
                  )}
                </p>
              </div>
            </div>
            <p className="ml-6 leading-[18px] text-[13px]">
              {isQuoteRequest
                ? "A sales representative will contact you to provide details on installation services and associated costs for this item."
                : "Installation + Required Parts"}
            </p>
            {addOnsPayload.installationServiceId && (
              <>
                {" "}
                {isMultipleInstallationService ? (
                  <MultipleInstallationService
                    installationService={installationService}
                    addOnsPayload={addOnsPayload}
                    setAddOnsPayload={setAddOnsPayload}
                  />
                ) : (
                  !isQuoteRequest && (
                    <>
                      {installation && (
                        <div className=" flex gap-2">
                          <span className=" w-4 ml-6">
                            <Image
                              src={RightMark}
                              alt="icon"
                              className=" w-[16px] h-[16px]"
                            />
                          </span>
                          <p className="text-[13px]">
                            {installation?.partName
                              ? installation?.partName
                              : "Installation "}{" "}
                            {installation.price
                              ? formatCurrency(installation.price)
                              : "Free"}
                          </p>
                        </div>
                      )}
                      {installationParts.length === 0 ? (
                        <div className=" flex gap-2">
                          <span className=" w-4 ml-6">
                            <Image
                              src={RightMark}
                              alt="icon"
                              className=" w-[16px] h-[16px]"
                            />
                          </span>
                          <p className="text-[13px]">No Parts Required</p>
                        </div>
                      ) : (
                        installationParts?.length > 0 && (
                          <>
                            {installationParts?.map((i) => (
                              <div className=" flex gap-2" key={i.partSKU}>
                                <span className=" w-4 ml-6">
                                  <Image
                                    src={RightMark}
                                    alt="icon"
                                    className=" w-[16px] h-[16px]"
                                  />
                                </span>
                                <p className="text-[13px]">
                                  {i.partName || "___"}{" "}
                                  {formatCurrency(i?.partPrice)}
                                </p>
                              </div>
                            ))}
                          </>
                        )
                      )}
                    </>
                  )
                )}
              </>
            )}
          </div>
          <div className="flex flex-col space-y-1 mt-3">
            <div className="flex items-center space-x-2">
              <Checkbox
                checked={
                  isQuoteRequest
                    ? !addOnsPayload.quoteOnly
                    : !addOnsPayload.installationServiceId
                }
                onCheckedChange={handleOnNoCheckedChange}
              />

              <div className="flex-1 flex items-center justify-between">
                <div className="inline-flex items-center gap-2">
                  <p className="text-[15px] leading-[23px]">
                    No, I’ll install it myself.
                  </p>
                </div>
              </div>
            </div>
            <p className="ml-6 leading-[18px] text-[13px]">
              In-box delivery only
            </p>
          </div>

          {!addOnsPayload.installationServiceId &&
            installationParts?.length > 0 &&
            !isMultipleInstallationService && (
              <OptOutOptions
                addOnsPayload={addOnsPayload}
                installationParts={installationParts}
                setAddOnsPayload={setAddOnsPayload}
              />
            )}
          {!addOnsPayload.installationServiceId &&
            isMultipleInstallationService && (
              <MultipleOptOutOptions
                addOnsPayload={addOnsPayload}
                setAddOnsPayload={setAddOnsPayload}
                installationService={installationService}
              />
            )}
        </div>
      )}
      {/* Additional Services Section */}
      {!isFetching && haulAwayService && (
        <div className="border border-gray-14 rounded-10 px-[14px] py-[18px] mt-[18px]">
          <div className="flex gap-4 border-b border-gray-14 pb-[18px] mb-[18px]">
            <Image
              src={AdServiceIcon}
              className="w-[27px] h-[27px] mt-4px"
              alt="icon"
            />
            <div>
              <h4 className="text-[17px] leading-[26px] font-medium mb-[5px]">
                Haul Away
              </h4>
            </div>
          </div>
          <div className="flex flex-col space-y-1 gap-[2px]">
            {haulAway && (
              <div className="flex items-start space-x-2">
                <Checkbox
                  checked={addOnsPayload?.additionServices?.haulaway}
                  onCheckedChange={(checked) =>
                    handleAdditionalCheckboxChange("haulaway", checked)
                  }
                />
                <p className="text-[15px] leading-[19px]">
                  Haul Away{" "}
                  <span className="font-medium">
                    {" "}
                    {getAdditionServicePriceLabel(haulAwayPrice)}
                  </span>
                </p>
              </div>
            )}
            {moveAway && (
              <div className="flex items-start space-x-2">
                <Checkbox
                  checked={addOnsPayload?.additionServices?.moveAway}
                  onCheckedChange={(checked) =>
                    handleAdditionalCheckboxChange("moveAway", checked)
                  }
                />
                <p className="text-[15px] leading-[19px] ">
                  Move Old Appliances to Other Room{" "}
                  <span className="font-medium">
                    {getAdditionServicePriceLabel(moveAwayPrice)}
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InstallationServices;

const MultipleInstallationService = ({
  installationService,
  addOnsPayload,
  setAddOnsPayload,
}) => {
  const {
    fixedServices = [],
    variableServices = [],
    installationFee,
  } = installationService[0] || {};

  return (
    <>
      <div className=" flex gap-2">
        <span className=" w-4 ml-2">
          <Image src={RightMark} alt="icon" className=" w-[16px] h-[16px]" />
        </span>
        <p className="text-[13px]">Installation Free</p>
      </div>
      {fixedServices?.map((service, index) => {
        const { partName, partPrice } = service;

        return (
          <div key={index} className=" flex gap-2">
            <span className=" w-4 ml-2">
              <Image
                src={RightMark}
                alt="icon"
                className=" w-[16px] h-[16px]"
              />
            </span>
            <p className="text-[13px]">
              {partName || "----"} {formatCurrency(partPrice)}
            </p>
          </div>
        );
      })}

      <div className="flex gap-4 ml-2">
        {variableServices?.map((service, index, array) => {
          const { partName, partPrice, installationServiceId } = service;

          return (
            <>
              <div key={index} className=" flex gap-2">
                <Checkbox
                  checked={
                    addOnsPayload.installationServiceId ===
                    installationServiceId
                  }
                  onCheckedChange={() => {
                    setAddOnsPayload((prev) => ({
                      ...prev,
                      installationServiceId,
                      installationService: { ...service, installationFee },
                    }));
                  }}
                />

                <p className="text-[13px]">
                  {partName || "----"} {formatCurrency(partPrice)}
                </p>
              </div>
              {index !== array.length - 1 && <p className="text-[13px]">or</p>}
            </>
          );
        })}
      </div>
    </>
  );
};

const OptOutOptions = ({
  addOnsPayload,
  installationParts,
  setAddOnsPayload,
}) => {
  return (
    <>
      <div className=" flex gap-2">
        <span className=" w-4 ml-6">
          <Image src={RightMark} alt="icon" className=" w-[16px] h-[16px]" />
        </span>
        <p className="text-[13px]">Required Parts For Installation </p>
      </div>
      {installationParts?.map((i) => (
        <div className="flex ml-12 py-0.5 gap-2" key={i.partId}>
          <Checkbox
            checked={addOnsPayload?.installationParts?.some(
              (service) => service.partId === i.partId || service === i.partId
            )}
            onCheckedChange={() => {
              setAddOnsPayload((prev) => {
                const isAlreadySelected = prev.installationParts?.some(
                  (service) => service.partId === i.partId
                );

                const updatedServices = isAlreadySelected
                  ? prev.installationParts?.filter((service) =>
                      service.partId
                        ? service.partId !== i.partId
                        : service !== i.partId
                    ) // Remove if already selected
                  : [...prev?.installationParts, i]; // Add if not selected

                return {
                  ...prev,
                  installationParts: updatedServices,
                };
              });
            }}
          />
          <p className="text-[13px]">
            {i.partName || "----"} {formatCurrency(i?.price)}
          </p>
        </div>
      ))}
    </>
  );
};

const MultipleOptOutOptions = ({
  addOnsPayload,
  installationService,
  setAddOnsPayload,
}) => {
  const { fixedServices = [], variableServices = [] } =
    installationService[0] || {};
  return (
    <>
      <div className=" flex gap-2 ml-2 mt-2">
        <p className="text-[13px]">Required Parts For Installation </p>
      </div>
      <div className="ml-2">
        {fixedServices?.map((service, index) => {
          const { partName, partPrice, partId } = service;

          const isChecked = addOnsPayload?.installationParts?.some(
            (service) => service === partId || service.partId === partId
          );

          return (
            <div key={index} className=" flex gap-2">
              <Checkbox
                checked={isChecked}
                onCheckedChange={() => {
                  setAddOnsPayload((prev) => {
                    const isAlreadySelected = isChecked;

                    const updatedServices = isAlreadySelected
                      ? prev.installationParts.filter((service) =>
                          service.partId
                            ? service.partId !== partId
                            : service !== partId
                        ) // Remove if already selected
                      : [...prev.installationParts, service]; // Add if not selected

                    return {
                      ...prev,
                      installationParts: updatedServices,
                    };
                  });
                }}
              />
              <p className="text-[13px]">
                {partName || "----"} {formatCurrency(partPrice)}
              </p>
            </div>
          );
        })}

        <div className="flex gap-4">
          {variableServices?.map((service, index, array) => {
            const { partName, partPrice, partId } = service;
            const isChecked = addOnsPayload?.installationParts?.some(
              (service) => service === partId || service.partId === partId
            );
            return (
              <React.Fragment key={index}>
                <div className="flex gap-2">
                  <Checkbox
                    checked={isChecked}
                    onCheckedChange={() => {
                      setAddOnsPayload((prev) => {
                        // Remove all previously selected variable services
                        let updatedServices = prev.installationParts.filter(
                          (s) =>
                            !variableServices?.some((v) =>
                              s.partId ? v.partId === s.partId : v.partId === s
                            )
                        );

                        // If the clicked checkbox is NOT already selected, add it
                        if (!isChecked) {
                          updatedServices = [...updatedServices, service];
                        }

                        return {
                          ...prev,
                          installationParts: updatedServices,
                        };
                      });
                    }}
                  />
                  <p className="text-[13px]">
                    {partName || "----"} {formatCurrency(partPrice)}
                  </p>
                </div>
                {index !== array.length - 1 && (
                  <p className="text-[13px]">or</p>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
};
